export default __webpack_public_path__ + "static/media/Acedol-Tabletfr.aac3d599.jpg";